import _ from 'lodash';

export const removeMask = (number: string | null) => number?.replace(/[^0-9]/g, '');

const allSameDigits = (digits: string) => /^(\d)\1+$/.test(digits);

const calcCpfDigit = (digits: string, factor: number): number => {
  const total = digits
    .split('')
    .reduce((sum, digit, index) => sum + Number(digit) * (factor - index), 0);
  const remainder = total % 11;
  return remainder < 2 ? 0 : 11 - remainder;
};

const calcCnpjDigit = (digits: string, weights: number[]): number => {
  const total = weights
    .reduce((sum, weight, index) => sum + Number(digits[index]) * weight, 0);
  const remainder = total % 11;
  return remainder < 2 ? 0 : 11 - remainder;
};

export const isValidCpf = (cpf: string): boolean => {
  const digits = removeMask(cpf) ?? '';
  if (digits.length !== 11 || allSameDigits(digits)) return false;

  const firstDigit = calcCpfDigit(digits.slice(0, 9), 10);
  const secondDigit = calcCpfDigit(digits.slice(0, 10), 11);

  return firstDigit === Number(digits[9]) && secondDigit === Number(digits[10]);
};

export const isValidCnpj = (cnpj: string): boolean => {
  const digits = removeMask(cnpj) ?? '';
  if (digits.length !== 14 || allSameDigits(digits)) return false;

  const firstWeights = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const secondWeights = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const firstDigit = calcCnpjDigit(digits.slice(0, 12), firstWeights);
  const secondDigit = calcCnpjDigit(digits.slice(0, 13), secondWeights);

  return firstDigit === Number(digits[12]) && secondDigit === Number(digits[13]);
};

export const isValidCpfOrCnpj = (value: string): boolean => {
  const digits = removeMask(value) ?? '';
  if (digits.length === 11) return isValidCpf(digits);
  if (digits.length === 14) return isValidCnpj(digits);
  return false;
};

export const titleCase = (str: string) => {
  if (typeof str !== 'string') return '';

  return _.startCase(_.toLower(str));
};

export const firstLastName = (str: string): string => {
  const nameSplit = str.split(' ');
  if (nameSplit.length < 2) throw new Error('É necessario informar o nome completo');
  return `${nameSplit[0]} ${nameSplit[nameSplit.length - 1]}`;
};
